<template>
  <body>
    <div class="market-style h-linePage h-header" id="app">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">
            <span style="color: #4a90e2">
              <i class="el-icon-location"></i>
              首页
            </span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>波谱</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="select">
          <!-- <el-select :no-data-text="$t('home.noData')" class="select-box" v-model="value3" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
          <div class="block">
            <el-date-picker v-model="value1" type="date" placeholder="选择日期"></el-date-picker>
            <span>时</span>
            <el-time-picker
              v-model="value2"
              format="HH:mm"
              value-format="HH:mm"
              :picker-options="{
                selectableRange: '00:00:00 - 23:59:59',
              }"
              placeholder="任意时间点"
            ></el-time-picker>
          </div>
          <el-button @click="affirm" class="btn" type="primary">确认</el-button>
        </div>
      </div>
      <div id="autoContent" style="  height: 90%; width: 100%">
        <div class="t-content andon" style="height: 100%">
          <div class="h100" style="height: 100%">
            <div class="h100" style="height: 100%" id="lineChart1"></div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
// 获取分页数据，保存，根据ID获取数据，批量删除数据
import Vue from 'vue'
import { getBopuList} from '../service/getData'
import * as echarts from 'echarts'
import 'echarts-gl'
import moment from 'moment'
Vue.prototype.$echarts = echarts
export default {
  name: 'basedataConfig',
  data() {
    return {
      // 表单检查规则
      rules: {},
      // 列表数量
      total: 0,
      //当前数据
      currentdata: '',
      //日产不良率
      dailyoutput: '',
      stationbadnessrate: '',
      topproblems: '',
      monthlybadnessrate: '',
      data1: '',
      form: {
        id: 19,
        Equipno: 66,
      },
      Equipno: '',
      value1: '',
      value2: '',
      queryInfo: {
        action: 'spectrogram',
        strDate: '2022071208',
      },
      totalRows: 0,
      time: '',
      bopudatarows: '',
      index: 0,
      bpdata: '',
      value3: '',
      options: [
        {
          value: '0',
          label: '解析方式1',
        },
        {
          value: '1',
          label: '解析方式2',
        },
        {
          value: '2',
          label: '解析方式3',
        },
      ],
      equipid: '',
    }
  },
  methods: {
    gettime() {
      this.value1 = moment().format('YYYY-MM-DD')
      this.value2 = moment().format('HH:mm')
      console.log(this.value2)
    },
    // 页面数据
    async getBopudataList(datatime,equipId) {
      const _this = this
      const { data } = await getBopuList({
        action: 'spectrogram',
        strDate: datatime,
        equipId: equipId,
      })
      // const { data1 } = await getnewBopuList({
      //   acttype: '0',
      //   strDate: datatime,
      // })
      // console.log(data1)
      this.bpdata = data
      // if (data.data != "") {
      //   this.bopudatarows = data.data.rows
      //   const arry = data.data.rows[index].json
      //   this.value1 = data.data.rows[index].time
      //   this.value2 = data.data.rows[index].time
      //   this.totalRows = data.data.totalRows
      //   this.queryInfo.PageNo = data.data.pageNo
      //   this.queryInfo.pageSize = data.data.totalRows
      //   var newarr = JSON.parse(JSON.stringify(JSON.parse(arry)))
      //   for (let index = 0 index < newarr.length index++) {
      //     newarr[index] = newarr[index].reverse()
      //   }
      this.data1 = data.s
      // console.log(this.data1, this.queryInfo)
      if (_this.data1 != '') {
        _this.echartsss()
      }
    },
    echartsss() {
      const _this = this
      var myChart = this.$echarts.init(document.getElementById('lineChart1'))
      var option
      var ymin = Math.min(...this.bpdata.freq).toFixed(2)
      var ymax = Math.max(...this.bpdata.freq).toFixed(2)
      var xmin = Math.min(...this.bpdata.dir)
      var xmax = Math.max(...this.bpdata.dir)
      var chazhi = xmax - xmin
      const jiange = Math.round(chazhi / 8)
      //初始化最大值
      var max = _this.data1[0][0]
      //初始化最小值
      var min = _this.data1[0][0]
      for (var i = 0; i < _this.data1.length; i++) {
        for (var j = 0; j < _this.data1[i].length; j++) {
          if (max < _this.data1[i][j]) {
            //比较最大值 比现有最大值小说明是最大值
            //示例:32<33 判断语句真,赋值33是max
            max = _this.data1[i][j]
          }
          if (min > _this.data1[i][j]) {
            //比较最小值 比现有最小值大说明是最小值
            //示例:32>12 判断语句真,赋值12是min
            min = _this.data1[i][j]
          }
        }
      }
      function generateData() {
        var data = []
        for (var i = 0; i < _this.data1.length; i++) {
          for (var j = 0; j < _this.data1[0].length; j++) {
            // var x = (max - min) * i / 200 + min;
            // var y = (max - min) * j / 100 + min;
            // data.push([i, j, noise.perlin2(i / 40, j / 20) + 0.5]);
            data.push([_this.bpdata.dir[j], _this.bpdata.freq[i], _this.data1[i][j]])
            // data.push([i, j, normalDist(theta, x) * normalDist(theta, y)]);
          }
        }
        return data
      }
      var data = generateData()
      option = {
        tooltip: {
          formatter: function (val) {
            console.log(val)
            const p = Math.floor(Math.log(val.data[2]) / Math.LN10)
            const n = val.data[2] * 10 ** -p
            const m = `${n}e${p}`
            const p1 = Math.floor(Math.log(val.data[1]) / Math.LN10)
            const n1 = val.data[1] * 10 ** -p1
            const m1 = `${n1}e${p1}`
            let res = `<div>
                        
                        <div style="margin-left: 0px"><span style="margin-top: 10px">${val.marker}</span> 角度(°) : ${val.data[0]}</div>
                        <div style="margin-left: 18px">频率(Hz) : ${m1}</div>
                        <div style="margin-left: 18px">功率(m^2s) : ${m}</div>
                    </div>`
            return res
          },
        },
        backgroundColor: '#fff',
        // visualMap: {
        //   show: false,
        //   dimension: 2,
        //   min: -1,
        //   max: 1,
        //   inRange: {
        //     color: [
        //       "#313695",
        //       "#4575b4",
        //       "#74add1",
        //       "#abd9e9",
        //       "#e0f3f8",
        //       "#ffffbf",
        //       "#fee090",
        //       "#fdae61",
        //       "#f46d43",
        //       "#d73027",
        //       "#a50026",
        //     ],
        //   },
        // },
        visualMap: {
          // min: -10e-7,
          // max: 20e-7,
          // splitNumber:8,
          min: min,
          max: max,
          precision: 9,
          // range: [-10e-7, -5e-7,10e-7,20e-7],
          // min: 0,
          // max: 1,
          // splitNumber: 10,
          itemHeight: 500, //图形的高度，即长条的高度。
          calculable: true,
          realtime: false,
          left: 'right',
          top: 'center',
          show: true,
          inRange: {
            color: ['#412CB9', '#2F8BF2', '#26C5A7', '#F3BA39', '#F3E527', '#F3F321'],
          },
          textStyle: {
            //图例文字的样式
            color: 'black',
          },
        },
        xAxis3D: {
          name: '角度(°)',
          splitNumber: 7,
          type: 'value',
          min: xmin,
          max: xmax,
          interval: jiange,
          axisLabel: {
            color: 'black',
            //函数模板
            formatter: function (category) {
              var chazhi = xmax - xmin
              const a = Math.round(chazhi / 8)
              var result = ''
              if (category >= xmin && category < xmin + a) {
                result = ''
                return result
              } else if (category >= xmin + a && category < xmin + a * 2) {
                result = 'SW'
                return result
              } else if (category >= xmin + a * 2 && category < xmin + a * 3) {
                result = 'W'
                return result
              } else if (category >= xmin + a * 3 && category < xmin + a * 4) {
                result = 'NW'
                return result
              } else if (category >= xmin + a * 4 && category < xmin + a * 5) {
                result = 'N'
                return result
              } else if (category >= xmin + a * 5 && category < xmin + a * 6) {
                result = 'NE'
                return result
              } else if (category >= xmin + a * 6 && category < xmin + a * 7) {
                result = 'E'
                return result
              } else if (category >= xmin + a * 7 && category < xmin + a * 8) {
                result = 'SE'
                return result
              } else if (category >= xmin + a * 8) {
                result = 'S'
                return result
              }
            },
          },
        },
        yAxis3D: {
          name: '频率(Hz)',
          type: 'value',
          max: ymax,
          min: ymin,
        },
        zAxis3D: {
          name: '功率(m^2s)',
          type: 'value',
          // max: max,
          // min: min,
        },
        grid3D: {
          viewControl: {
            // projection: 'orthographic'
          },
          boxHeight: 40,
        },
        series: [
          {
            type: 'surface',
            wireframe: {
              show: false,
            },
            shading: 'color',
            zlevel: -10,
            // equation: {
            //   x: {
            //     step: 0.05,
            //     min: -3,
            //     max: 3,
            //   },
            //   y: {
            //     step: 0.05,
            //     min: -3,
            //     max: 3,
            //   },
            //   z: function (x, y) {
            //     return Math.sin(x) / 3.14
            //   },
            // },
            data: data,
            //改成ml
          },
        ],
      }
      option && myChart.setOption(option)
    },
    affirm() {
      this.time = moment(this.value1).format('YYYYMMDD') + this.value2.slice(0, 2)
      this.getBopudataList(this.time,this.equipid)
    },
    //页面条数
    //页数改变
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      console.log('.....', newPage)
    },
  },
  computed: {
    roundone() {
      return 2 * Math.PI * 61
    },
  },
  mounted: function () {
    this.gettime()
    this.Equipno = this.$route.params.Equipno
    this.equipid = this.$route.params.Equipid
    this.datatime =  moment(this.value1).format('YYYYMMDD') + this.value2.slice(0, 2)
    console.log(this.Equipno, this.$route.params.Equipid,moment().format('YYYYMMDD'))
    //获取到选着的语言
    if (localStorage.lang) {
      var lang = localStorage.lang
      this.$i18n.locale = lang
    }
    // this.echartsss()
    this.getBopudataList(this.datatime,this.equipid)
    
  },
}
</script>
<style lang="scss" scoped>
body {
  color: #3aa9cf;
  // height: 1080px;
  .select {
    display: flex;
    margin-top: 15px;
  }
  .select-box {
    margin-right: 15px;
  }
  // #lineChart1{
  // }
}
</style>
